/*
 * Copyright (c) 2025.  Chad and contributors.
 * All rights reserved.
 */

import {useStore} from 'vuex';
import {computed} from 'vue';

export function useProviders() {
    const store = useStore();

    const paymentProviders = computed(() => store.getters['providers/paymentProviders']);

    const getProviders = () => {
        return store.dispatch('providers/getProviders');
    }

    const deletePaymentProfile = async (payload: string | { uuid: string }) => {
        return await store.dispatch('providers/deletePaymentProfile', payload);
    }

    const getPaymentProfiles = () => {
        return store.dispatch('providers/getPaymentProfiles');
    }

    return {
        paymentProviders,
        getProviders,
        deletePaymentProfile,
        getPaymentProfiles,
    }
}